import { model as $router } from '!/router'
import {
  attach,
  createEvent,
  createStore,
  sample,
  scopeBind,
  type EventCallable,
  type StoreWritable,
} from 'effector'
import { ONE_SECOND_MS } from '~/shared/constants'
import {
  NotificationKind,
  type NotificationPayload,
  type NotificationState,
} from './index.h'

const NOTIFICATION_DURATION = ONE_SECOND_MS * 4

// the only way to raise the toast — every feature that has something to say
// goes through it, so the timeout and the hide-on-navigation rule stay in one place
export const showNotification: EventCallable<NotificationPayload> =
  createEvent()

const hideNotification = createEvent()

export const $notification: StoreWritable<NotificationState> =
  createStore<NotificationState>({
    isVisible: false,
    text: '',
    icon: null,
    kind: NotificationKind.Default,
  })
    .on(
      showNotification,
      (_, { text, icon, kind = NotificationKind.Default }) => ({
        isVisible: true,
        text,
        icon,
        kind,
      })
    )
    .on(hideNotification, (state) => ({
      ...state,
      isVisible: false,
    }))

// timeout id, which is used to clear timeout
const $timeout = createStore<ReturnType<typeof setTimeout> | null>(null)

const setClearTimeoutFx = attach({
  source: $timeout,
  effect: (timeout) => {
    if (timeout != null) clearTimeout(timeout)
    const hideNotificationBound = scopeBind(hideNotification, { safe: true })
    return setTimeout(hideNotificationBound, NOTIFICATION_DURATION)
  },
})

sample({
  clock: showNotification,
  target: setClearTimeoutFx,
})

// set timeout id
sample({
  clock: setClearTimeoutFx.doneData,
  target: $timeout,
})

// Hide notification when page changed
sample({
  clock: $router.$pathname,
  target: hideNotification,
})
